import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./AbourUs.css";
import AboutPic from "../../assets/about.jpg";
import { t } from "i18next";

const partners = [
  "sam", "women", "lukr", "bon", "msdu",
  "balu", "etoc", "emaus", "nord", "paci",
  "novaposhta", "helvet", "moj", "philua", "helpp",
  "forp", "omb", "geek", "loc", "cms"
];

const cooperation = [
  ["cooperation1.jpg", "about page reg 1"],
  ["cooperation2.jpg", "about page reg 2"],
  ["cooperation3.jpg", "about page reg 3"],
  ["cooperation4.jpg", "about page reg 4"],
  ["cooperation5.jpg", "about page reg 5"],
  ["cooperation6.jpg", "about page reg 6"]
];

const ibans = {
  UAH: "UA173052990000026009013609953",
  USD: "UA443052990000026002033606449",
  EUR: "UA763052990000026002033608395"
};

function fallback(key, value) {
  const translated = t(key);
  return translated && translated !== key ? translated : value;
}

function CopyIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0 1919.887h1467.88V452.008H0v1467.88ZM1354.965 564.922v1242.051H112.914V564.922h1242.051ZM1920 0v1467.992h-338.741v-113.027h225.827V112.914H565.035V338.74H452.008V0H1920ZM338.741 1016.93h790.397V904.016H338.74v112.914Zm0 451.062h790.397v-113.027H338.74v113.027Zm0-225.588h564.57v-112.913H338.74v112.913Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

function AccountCard({ currency, title, rows, copied, onCopy }) {
  return (
    <article className="skyua-about__account-card">
      <div className="skyua-about__account-head">
        <span>{currency}</span>
        <h3>{title}</h3>
      </div>

      <div className="skyua-about__account-body">
        {rows.map((row, index) => {
          if (row.section) {
            return (
              <div className="skyua-about__account-subtitle" key={`${currency}-${index}`}>
                {row.section}
              </div>
            );
          }

          return (
            <div className="skyua-about__account-row" key={`${currency}-${index}`}>
              <span>{row.label}</span>

              <div>
                {row.value}

                {row.copy && (
                  <button
                    type="button"
                    className={copied === currency ? "is-copied" : ""}
                    aria-label={`Copy ${currency} IBAN`}
                    onClick={() => onCopy(currency)}
                  >
                    <CopyIcon />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="skyua-about__copy-status" aria-live="polite">
        {copied === currency ? fallback("copied", "Скопійовано") : ""}
      </div>
    </article>
  );
}

export default function AboutPage() {
  const [copied, setCopied] = useState("");

  async function copyIban(currency) {
    try {
      await navigator.clipboard.writeText(ibans[currency]);
      setCopied(currency);
      window.setTimeout(() => {
        setCopied((current) => (current === currency ? "" : current));
      }, 1500);
    } catch (error) {
      console.error("Unable to copy IBAN", error);
    }
  }

  const accountData = [
    {
      currency: "UAH",
      title: t("requisites title UAH"),
      rows: [
        { section: t("requisites second title") },
        { label: t("Recipient's name"), value: "БО БФ НЕБО УКРАЇНИ" },
        { label: t("Recipient's code"), value: "44860393" },
        { label: t("Name of the bank"), value: "АТ КБ «ПриватБанк»" },
        { label: t("IBAN Code"), value: ibans.UAH, copy: true },
        { label: `${t("Currency")}:`, value: "UAH" }
      ]
    },
    {
      currency: "USD",
      title: t("requisites title USD"),
      rows: [
        { section: t("requisites second title") },
        { label: t("Company details"), value: "БФ НЕБО УКРАЇНИ" },
        { label: t("IBAN Code"), value: ibans.USD, copy: true },
        {
          label: t("Name of the bank"),
          value: 'JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE'
        },
        { label: t("Bank SWIFT Code"), value: "PBANUA2X" },
        {
          label: t("Company address"),
          value: "UA 90436 Закарпатська Хустський с Iза вул Мiчурiна б.5"
        },
        { section: t("Correspondent banks") },
        { label: t("Account in the correspondent bank"), value: "001-1-000080" },
        { label: t("SWIFT Code of the correspondent bank"), value: "CHASUS33" },
        { label: t("Correspondent bank"), value: "JP Morgan Chase Bank, New York, USA" },
        { section: t("or") },
        { label: t("Account in the correspondent bank"), value: "890-0085-754" },
        { label: t("SWIFT Code of the correspondent bank"), value: "RVT US 3N" },
        { label: t("Correspondent bank"), value: "The Bank of New York Mellon, New York, USA" },
        { label: t("Account in the correspondent bank"), value: "36445343" },
        { label: t("SWIFT Code of the correspondent bank"), value: "CITI US 33" },
        { label: t("Correspondent bank"), value: "Citibank N.A., NEW YORK, USA" }
      ]
    },
    {
      currency: "EUR",
      title: t("requisites title EUR"),
      rows: [
        { section: t("requisites second title") },
        { label: t("Company details"), value: "БФ НЕБО УКРАЇНИ" },
        { label: t("IBAN Code"), value: ibans.EUR, copy: true },
        {
          label: t("Name of the bank"),
          value: 'JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE'
        },
        { label: t("Bank SWIFT Code"), value: "PBANUA2X" },
        {
          label: t("Company address"),
          value: "UA 90436 Закарпатська Хустський с Iза вул Мiчурiна б.5"
        },
        { section: t("Correspondent banks") },
        { label: t("Account in the correspondent bank"), value: "400886700401" },
        { label: t("SWIFT Code of the correspondent bank"), value: "COBADEFF" },
        { label: t("Correspondent bank"), value: "Commerzbank AG, Frankfurt am Main, Germany" },
        { section: t("or") },
        { label: t("Account in the correspondent bank"), value: "6231605145" },
        { label: t("SWIFT Code of the correspondent bank"), value: "CHASDEFX" },
        { label: t("Correspondent bank"), value: "J.P.MORGAN AG, FRANKFURT AM MAIN, GERMANY" }
      ]
    }
  ];

  return (
    <main className="skyua-about">
      <section className="skyua-about__hero">
        <div className="skyua-about__container skyua-about__hero-grid">
          <div>
            <span className="skyua-about__eyebrow">
              {fallback("about page eyebrow", "Про фонд")}
            </span>

            <h1>{t("about page name")}</h1>
            <p>{t("about page p1")}</p>

            <div className="skyua-about__hero-stats">
              <div><strong>2022</strong><span>{t("about page vol 3")}</span></div>
              <div><strong>50+</strong><span>{fallback("about page team total", "Команда фонду")}</span></div>
              <div><strong>7</strong><span>{fallback("about page regions total", "Областей роботи")}</span></div>
            </div>
          </div>

          <div className="skyua-about__hero-photo">
            <img src={AboutPic} alt="about" />
          </div>
        </div>
      </section>

      <section className="skyua-about__section">
        <div className="skyua-about__container">
          <div className="skyua-about__heading">
            <span className="skyua-about__eyebrow">
              {fallback("about page activity title", "Наша діяльність")}
            </span>
            <h2>{fallback("about page activity heading", "Системна допомога людям і громадам")}</h2>
          </div>

          <div className="skyua-about__story">
            <img
              src={require("../../assets/impact/img1.jpg")}
              alt="help"
              className="skyua-about__story-image"
            />
            <div className="skyua-about__story-copy">
              <p>{t("about page p2")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="skyua-about__section skyua-about__section--soft">
        <div className="skyua-about__container">
          <div className="skyua-about__heading">
            <span className="skyua-about__eyebrow">
              {fallback("about page team eyebrow", "Про команду")}
            </span>
            <h2>{t("about page p3")}</h2>
          </div>

          <div className="skyua-about__team">
            <div className="skyua-about__team-stats">
              <div><span>{t("about page vol 3")}</span><strong>2022</strong></div>
              <div><span>{t("about page vol 4")}</span><strong>{t("about page vol 5")}</strong></div>
              <div><span>{t("about page vol 1")}</span><strong>20</strong></div>
              <div><span>{t("about page vol 2")}</span><strong>30</strong></div>
            </div>

            <div className="skyua-about__team-story">
              <p className="skyua-about__team-highlight">{t("about page vol 6")}</p>
              <div>
                <p>{t("about page vol 7")}</p>
                <p>{t("about page vol 8")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="skyua-about__section">
        <div className="skyua-about__container">
          <div className="skyua-about__heading skyua-about__heading--row">
            <div>
              <span className="skyua-about__eyebrow">
                {fallback("partners title", "Партнери")}
              </span>
              <h2>{fallback("partners subtitle", "Організації, з якими ми діємо разом")}</h2>
            </div>

            <button type="button" className="skyua-about__partners-button">
              {fallback("about page p4", "Усі партнери")} <span>↗</span>
            </button>
          </div>

          <Row className="g-3">
            {partners.map((partner) => (
              <Col xs={6} md={3} lg={3} key={partner}>
                <div className="skyua-about__partner-card">
                  <img
                    src={require(`../../assets/partners/${partner}.png`)}
                    alt={partner}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="skyua-about__section skyua-about__section--soft">
        <div className="skyua-about__container">
          <div className="skyua-about__heading">
            <span className="skyua-about__eyebrow">
              {fallback("cooperation eyebrow", "Співпраця")}
            </span>
            <h2>{t("about page p5")}</h2>
          </div>

          <Row className="g-4">
            {cooperation.map(([image, textKey], index) => (
              <Col md={4} sm={6} xs={12} key={image}>
                <article className="skyua-about__cooperation-card">
                  <div>
                    <img
                      src={require(`../../assets/cooperation/${image}`)}
                      alt={`cooperation-${index + 1}`}
                    />
                    <span>{String(index + 1).padStart(2, "0")}</span>
                  </div>
                  <p>{t(textKey)}</p>
                </article>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="skyua-about__section skyua-about__requisites">
        <div className="skyua-about__container">
          <div className="skyua-about__heading">
            <span className="skyua-about__eyebrow">{t("requisites")}</span>
            <h2>{fallback("requisites heading", "Підтримати діяльність фонду")}</h2>
            <p className="skyua-about__requisites-intro">{t("Account det p")}</p>
          </div>

          <Row className="g-4 skyua-about__accounts-grid">
            {accountData.map((account) => (
              <Col lg={4} md={12} key={account.currency}>
                <AccountCard
                  {...account}
                  copied={copied}
                  onCopy={copyIban}
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </main>
  );
}
